import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../Reducer/authReducer";
import toast from "react-hot-toast";
import { FaBell } from "react-icons/fa";
import Notification from "./NotificationBox";
import { DEFAULTIMAGEURL, IMAGEURL } from "../Utils/EndPoint";
import { setError } from "../Reducer/chatReducer";

const Header = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [notificationOpen, setNotificationOpen] = useState(false);
  const { user } = useSelector((state) => state.Auth);
  const { count } = useSelector((state) => state.Notification);

  const dropdownRef = useRef(null);


  const handleProfile = () => {
    navigate("/profile");
    setDropdownOpen(false)
  };

  const handleLogout = () => {
    toast.success("User Logout Successfully");
    dispatch(logout());
    localStorage.removeItem("jwt-token");
    navigate("/login");
  };

  const handleNotificationClick = () => {
    setNotificationOpen(!notificationOpen);
  };
  const handleLogo = () => {
    navigate("/");
    dispatch(setError(null))
  }
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <header className="bg-gray-800 text-white shadow-md">
      <div className="container mx-auto flex items-center justify-between py-4 px-6">

        <div className="text-2xl font-bold">
          <img
            src="./chat-logo.jpeg"
            onClick={() => handleLogo()}
            width={50}
            alt="logo"
            className="border rounded-md cursor-pointer"
          />
        </div>

        <div className="relative flex items-center space-x-4">
          <div className="relative" >
            <FaBell
              className="text-2xl cursor-pointer"
              onClick={handleNotificationClick}
            />
            {count > 0 && (
              <span className="absolute -top-2 -right-2 bg-red-500 text-white text-xs w-5 h-5 flex items-center justify-center rounded-full">
                {count}
              </span>
            )}
          </div>

          <span className="text-lg hidden sm:block">
            {user.firstName + " " + user.lastName}
          </span>
          <div ref={dropdownRef}>
            <button
              onClick={() => setDropdownOpen(!dropdownOpen)}
              className="relative focus:outline-none"
            >
              <img
                src={user.image ? `${IMAGEURL}/${user.image}` : DEFAULTIMAGEURL}
                alt={`${user.firstName}'s profile`}
                className="w-10 h-10 rounded-full object-cover"
              />
            </button>

            {/* Dropdown */}
            {dropdownOpen && (
              <div className="absolute right-0 w-32 top-12 bg-gray-200 text-black rounded-md shadow-lg z-10">
                <ul className="py-1">
                  <li
                    className="block px-4 py-2 hover:font-bold cursor-pointer"
                    onClick={handleProfile}
                  >
                    Profile
                  </li>
                  <li
                    className="block px-4 py-2 hover:font-bold cursor-pointer"
                    onClick={handleLogout}
                  >
                    Logout
                  </li>
                </ul>
              </div>
            )}
          </div>
        </div>
      </div>
      {notificationOpen && (
        <Notification handleNotificationClick={handleNotificationClick} />
      )}
    </header>
  );
};

export default Header;
